<template>
    <div>
        <b-row class="panel-title">
            <label class="col-lg-6 Intercompany-Agency">PROFILE UNLOCK REQUEST DETAILS</label>
        </b-row>
        <b-row class="panel-content">
            <b-col cols="lg-4">
                <label>Entity</label>
                <p>{{ProfileUnlockRequestDetail.Entity}}</p>
            </b-col>
            <b-col cols="lg-4">
                <label>AGENCY NAME</label>
                <p>{{ProfileUnlockRequestDetail.Agency}}</p>
            </b-col>
            <b-col cols="lg-4">
                <label>ARE YOU CHANGING DOLLARS ON THE BUY?</label>
                <p>{{FormatBoolean(ProfileUnlockRequestDetail.ChangingDoller)}}</p>
            </b-col>
            <b-col cols="lg-4" v-if="ProfileUnlockRequestDetail.ChangingDoller == true">
                <label>ORIGINAL BUY AMOUNT</label>
                <p>{{formatDollar(ProfileUnlockRequestDetail.OriginalBuyAmount)}}</p>
            </b-col>
            <b-col cols="lg-4" v-if="ProfileUnlockRequestDetail.ChangingDoller == true">
                <label>NEW BUY AMOUNT</label>
                <p>{{formatDollar(ProfileUnlockRequestDetail.NewBuyAmount)}}</p>
            </b-col>
            <b-col cols="lg-4">
                <label>WILL YOUR CHANGE CREATE ADDITIONAL BILLING TO THE CLIENT?</label>
                <p>{{FormatBoolean(ProfileUnlockRequestDetail.AdditionalBilling)}}</p>
            </b-col>
            <b-col cols="lg-4">
                <label>ARE YOU ADJUSTING A PREVIOUSLY CLEARED BUY?</label>
                <p>{{FormatBoolean(ProfileUnlockRequestDetail.ClearedBuy)}}</p>
            </b-col>
            <b-col cols="lg-4" v-if="ProfileUnlockRequestDetail.ClearedBuy">
                <label>Do you have a revised invoice from the vendor to support this change?</label>
                <p>{{FormatBoolean(ProfileUnlockRequestDetail.RevisedInvoice)}}</p>
            </b-col>
            <b-col cols="lg-4">
                <label>SPECIFY THE TIME PERIOD OF THE BUY</label>
                <p>{{FormatDate(ProfileUnlockRequestDetail.Month)}} </p>
            </b-col>
            <b-col cols="lg-4" v-if="ProfileUnlockRequestDetail.TimeFrameFiles != null && ProfileUnlockRequestDetail.TimeFrameFiles.length > 0">
                <label>INVOICE COPY</label>
                <div>
                    <div v-for="file in ProfileUnlockRequestDetail.TimeFrameFiles"
                         :key="file.Name">
                        <span v-if="file.FullName">
                            <a class="file-ref"
                               :href="file.Name"
                               @click.prevent="downloadItem(file)"
                               target="_blank"
                               download>{{ file.Name }}</a>
                        </span>
                        <span v-else>
                            <span>{{ file.Name }}</span>
                        </span>
                    </div>
                </div>
            </b-col>

            <b-col cols="lg-4">
                <label>TOOLKIT</label>
                <p v-if="ProfileUnlockRequestDetail.Toolkit == 'PrintPrisma'">PRINT/PRISMA</p>
                <p v-else>{{ProfileUnlockRequestDetail.Toolkit}}</p>
            </b-col>
            <b-col cols="lg-4">
                <label>{{ProfileUnlockRequestDetail.Toolkit == 'PrintPrisma' ? 'Mediaocean Supplier' : 'Network'}}</label>
                <p>{{ProfileUnlockRequestDetail.SupplierName}}</p>
            </b-col>
            <b-col cols="lg-4">
                <label>MEDIA TYPE</label>
                <p>{{ProfileUnlockRequestDetail.UnlockMediaType}} </p>
            </b-col>
            <b-col cols="lg-4">
                <label>CLIENT CODE</label>
                <p>
                    {{ProfileUnlockRequestDetail.ClientCode}}
                </p>
            </b-col>
            <b-col cols="lg-4" v-if="ProfileUnlockRequestDetail.Product">
                <label>PRODUCT</label>
                <p>
                    {{ProfileUnlockRequestDetail.Product}}
                </p>
            </b-col>
            <b-col cols="lg-4" v-if="ProfileUnlockRequestDetail.Estimate">
                <label>ESTIMATE</label>
                <p>
                    {{ProfileUnlockRequestDetail.Estimate}}
                </p>
            </b-col>
            <b-col cols="lg-4">
                <label v-if="ProfileUnlockRequestDetail.Toolkit == 'Net'">NET TOOLKIT EXPLANATION</label>
                <label v-else-if="ProfileUnlockRequestDetail.Toolkit == 'PrintPrisma'">PRINT/PRISMA TOOLKIT EXPLANATION</label>
                <label v-else>TOOLKIT EXPLANATION</label>
                <p>{{ProfileUnlockRequestDetail.Reason}} </p>
            </b-col>
            <b-col cols="lg-4" v-if="ProfileUnlockRequestDetail.Camplink">
                <label>PRISMA CAMPAIGN LINK</label>
                <p>{{ProfileUnlockRequestDetail.Camplink}}</p>
            </b-col>
            <b-col cols="lg-4">
                <label>REQUESTOR</label>
                <p>{{ProfileUnlockRequestDetail.Requestor}} </p>
            </b-col>

            <b-col cols="lg-4" v-if="ProfileUnlockRequestDetail.ErrorFiles != null">
                <label>SCREENSHOT OF ERROR</label>
                <div>
                    <div v-for="file in ProfileUnlockRequestDetail.ErrorFiles"
                         :key="file.Name">
                        <span v-if="file.FullName">
                            <a class="file-ref"
                               :href="file.Name"
                               @click.prevent="downloadItem(file)"
                               target="_blank"
                               download>{{ file.Name }}</a>
                        </span>
                        <span v-else>
                            <span>{{ file.Name }}</span>
                        </span>
                    </div>
                </div>
            </b-col>
            <b-col cols="lg-4" v-if="ProfileUnlockRequestDetail.BPMApprover">
                <label>BPM APPROVER</label>
                <p class="mb-0" v-for="data in formatBPMApprover" :key="data">
                    {{data}}
                </p>
            </b-col>
            <b-col cols="lg-4"
                   v-if="ProfileUnlockRequestDetail.UnlockErrorMessage !=null">
                <label>ERROR MESSAGE</label>
                <p>{{ProfileUnlockRequestDetail.UnlockErrorMessage}} </p>
            </b-col>
            <b-col v-if="ProfileUnlockRequestDetail.UserError"
                   cols="lg-8">
                <label>USER ERROR MESSAGE</label>
                <p>{{ProfileUnlockRequestDetail.UserError}} </p>
            </b-col>
        </b-row>
    </div>
</template>

<style scope>
    @media screen and (min-width: 1200px) {
        .icreview-component {
            padding: 1rem 3rem 0px !important;
            height: 600px !important;
        }
    }

    .file-ref {
        color: #00a1d2 !important;
    }

    .Intercompany-Agency {
        font-size: 14px;
        font-family: "Open Sans";
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #4d5161 !important;
        text-transform: none;
    }

    .panel-list:not(.media-dropdowns) {
        padding-left: 2.5rem;
        padding-right: 2.5rem;
    }

    .panel-list .panel-body .panel-title {
        border-bottom: 1px solid rgba(151, 151, 151, 0.2);
        width: 100%;
        margin-left: 0px;
        margin-bottom: 25px !important;
    }

        .panel-list .panel-body .panel-title label {
            color: #77a2bb;
            margin-bottom: 0px !important;
            padding-top: 13px !important;
            font-family: "Open Sans";
            font-size: 14px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: 0.57;
            letter-spacing: normal;
            padding-left: 0px !important;
            min-height: 35px;
        }

        .panel-list .panel-body .panel-title .btn {
            padding-left: 5px;
            padding-right: 5px;
        }

        .panel-list .panel-body .panel-title > div {
            padding-right: 0px !important;
            float: right;
            font-family: "Open Sans";
            font-size: 12px;
            font-weight: 600;
            font-stretch: normal;
            font-style: normal;
            line-height: 0.75;
            letter-spacing: normal;
            color: #00a1d2;
        }

    .panel-list .panel-content label {
        text-transform: uppercase;
        color: #2c3865;
        font-size: 12px;
        margin-bottom: 1px !important;
        padding-left: 0px;
    }

    .panel-list .panel-content p {
        text-transform: uppercase;
        color: #4d5161;
        font-size: 14px;
        font-weight: 600;
    }

    .panel-content.row > div > label:first-child {
        color: #a2a9ad !important;
        font-family: "Open Sans" !important;
        font-size: 10px;
        font-weight: 600 !important;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.42;
        letter-spacing: normal;
    }

    .panel-content.row > div > *:not(:first-child) {
        font-family: "Open Sans" !important;
        font-size: 14px !important;
    }

    .panel-content.row > div > div {
        font-family: "Open Sans";
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        color: #4d5161;
    }

    .panel-list > .panel-body {
        margin-top: 1rem !important;
    }

    .panel-content.row > div {
        margin-bottom: 10px !important;
    }
</style>

<script>
    import moment from "moment";

    export default {
        props: {
            ProfileUnlockRequestDetail: {
                required: true,
                type: Object,
            }
        },
        computed:{
            formatBPMApprover() {
                return this.ProfileUnlockRequestDetail.BPMApprover.split(',')
            }
        },
        methods: {
            FormatDate(date) {
                return date != null && moment(new Date(date)).isValid()
                    ? moment(date).format("YYYY/MM")
                    : "-";
            },
            FormatBoolean(data) {
                if (data)
                    return "Yes";
                else if (!data)
                    return "No";
                else
                    return data;
            },
            formatDollar(data) {
                return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(data)
            },
            async downloadItem(file) {
                this.$store
                    .dispatch("profileUnlock/DownloadFile", file)
                   .then((response) => {
                        const blob = new Blob([response.data], { type: file.Extension });
                        const link = document.createElement("a");
                        link.href = URL.createObjectURL(blob);
                        link.download = file.Name;
                        link.click();
                        URL.revokeObjectURL(link.href);
                    })
                    .catch((ex) => {
                        if (ex.response) {
                            this.$store.dispatch(
                                "progress/setErrorMessage",
                                `Error while downloading file. ${ex.response.data}`
                            );
                        } else {
                            this.$store.dispatch(
                                "progress/setErrorMessage",
                                `Error while downloading file. ${ex}`
                            );
                        }
                    });
            },
            FilesUploaded() {
                let html = [];
                if (this.DownloadableFiles) {
                    this.ProfileUnlockRequestDetail.Files.forEach((element) => {
                        html.push(element);
                    });
                } else {
                    this.ProfileUnlockRequestDetail.Files.forEach((element) => {
                        html.push(element);
                    });
                }
                return html;
            },
        }
    }
</script>
